const LAYOUT_TYPES = {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal",
}

const SKIN_LAYOUT_TYPES = {
    DEFAULT: "default",
    BORDERED: "bordered",
}

const LAYOUT_MODE_TYPES = {
    LIGHTMODE: "light",
    DARKMODE: "dark"
}

const LAYOUT_DIRECTION = {
    LTR: "ltr",
    RTL: "rtl"
}

const LAYOUT_WIDTH_TYPES = {
    FLUID: "fluid",
    BOXED: "boxed"
}

const LEFT_SIDEBAR_SIZE = {
    DEFAULT: "lg",
    COMPACT: "md",
    SMALL: "sm"
}

const NAVIGATION_TYPES = {
    STICKY: "sticky",
    SCROLL: "scroll",
    BORDERED: "bordered",
    HIDDEN: "hidden"
}

const SIDEBAR_COLOR_TYPES = {
    LIGHT: "light",
    DARK: "dark",
    BRAND: "brand",
    MODERN: "modern",
}

const TOPBAR_COLOR_TYPES = {
    LIGHT: "light",
    DARK: "dark",
    BRAND: "brand"
}

export {
    LAYOUT_TYPES,
    SKIN_LAYOUT_TYPES,
    LAYOUT_MODE_TYPES,
    LAYOUT_DIRECTION,
    LAYOUT_WIDTH_TYPES,
    LEFT_SIDEBAR_SIZE,
    NAVIGATION_TYPES,
    SIDEBAR_COLOR_TYPES,
    TOPBAR_COLOR_TYPES,
}